import React from 'react';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  TooltipProps,
  BarProps,
} from 'recharts';

import useWindowDimensions from '~/hooks/dimensions';

import { Desktop, Mobile, Description } from './styles';

import RelatorioVendaCategoriasCategoria from '~/@types/relatoriovendacategoriascategoria';

import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

import { GraficoProps } from './interface';

interface CustomTooltipProps extends TooltipProps<ValueType, NameType> {}

interface CustomBarProps extends BarProps {
  payload?: RelatorioVendaCategoriasCategoria;
}

const exibicaoTotalPedidos = (pTotalPedidos: number) => {
  if (!pTotalPedidos) return 'Nenhum pedido';
  if (pTotalPedidos === 1) {
    return 'Um pedido';
  }
  return `${pTotalPedidos} pedidos`;
};

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && Array.isArray(payload) && payload.length) {
    const [cPayload] = payload;

    if (cPayload) {
      const { payload: _payload } = cPayload;
      if (_payload) {
        const item: RelatorioVendaCategoriasCategoria = {
          ..._payload,
        };

        return (
          <Description>
            <div>
              <h1>{item.nome}</h1>
              <h2>{exibicaoTotalPedidos(item.pedidos)}</h2>
              <ins />
              <h4>
                TICKET MÉDIO:{' '}
                <b>
                  {item.ticketmedio.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </b>
              </h4>
              <h5>
                TOTAL:
                <b>
                  {item.total.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </b>
              </h5>
            </div>
          </Description>
        );
      }
    }
  }

  return null;
};

const Grafico: React.FC<GraficoProps> = ({ categorias }) => {
  const { width } = useWindowDimensions();

  let _height = categorias.length * 100;
  if (_height <= 200) {
    _height = 200;
  }

  return (
    <>
      <Desktop>
        <ResponsiveContainer>
          <BarChart
            data={categorias}
            margin={{
              top: 0,
              right: 10,
              left: 30,
              bottom: 25,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />

            <YAxis
              tickFormatter={value =>
                `${value.toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL',
                })}`
              }
              tick={{ fill: '#999', fontSize: 8 }}
            />

            <XAxis
              dataKey="posicao"
              stroke={'#999'}
              fontSize={10}
              angle={0}
              textAnchor="end"
              tickMargin={10}
              dx={25}
            />

            <Tooltip
              content={<CustomTooltip />}
              cursor={{ fill: 'rgba(255,255,255, 0.1)' }}
            />

            <YAxis />
            <Tooltip />

            <Bar
              type="monotone"
              dataKey={'total'}
              radius={[6, 6, 0, 0]}
              fill="#666"
            />
          </BarChart>
        </ResponsiveContainer>
      </Desktop>

      <Mobile
        style={{
          height: _height,
        }}
      >
        <ResponsiveContainer>
          <BarChart
            data={categorias}
            layout="vertical"
            margin={{
              top: 10,
              right: 20,
              left: -40,
              bottom: 20,
            }}
            width={width}
          >
            <CartesianGrid strokeDasharray="3 3" />

            <XAxis type="number" hide />

            <YAxis
              type="category"
              dataKey="posicao"
              tick={false}
              tickLine={false}
              axisLine={false}
            />

            <Tooltip
              content={<CustomTooltip />}
              cursor={{ fill: 'rgba(255,255,255, 0.1)' }}
            />

            <Tooltip />

            <Bar
              type="monotone"
              dataKey={'total'}
              radius={[0, 8, 8, 0]}
              fill="#666"
            />
          </BarChart>
        </ResponsiveContainer>
      </Mobile>
    </>
  );
};

export default Grafico;
